export default (
  state = {
    DocumentItem: {
      settings_document_revalidation_date: {
        label: "settings_document_revalidation_date",
        data: "revalidationDate",
      },
      settings_document_created_date: {
        label: "settings_document_created_date",
        data: "dateCreated",
      },
      settings_document_last_date_modified: {
        label: "settings_document_last_date_modified",
        data: "dateModified",
      },
      settings_document_number_of_liked: {
        label: "settings_document_number_of_liked",
        data: "likedCount",
      },
      settings_document_number_of_times_favourited: {
        label: "settings_document_number_of_times_favourited",
        data: "favouritedCount",
      },
      settings_document_number_of_times_viewed: {
        label: "settings_document_number_of_times_viewed",
        data: "viewedCount",
      },
      settings_document_number_of_times_used: {
        label: "settings_document_number_of_times_used",
        data: "usedCount",
      },
      settings_document_date_last_viewed_by_me: {
        label: "settings_document_date_last_viewed_by_me",
        data: "myLastViewed",
      },
      settings_document_user_who_last_modified: {
        label: "settings_document_user_who_last_modified",
        data: "lastModifiedByUser",
      },
      settings_document_rework_count: {
        label: "settings_document_rework_count",
        data: "reworkCount",
      },
      settings_document_author: {
        label: "settings_document_author",
        data: "author",
      },
      settings_document_live_revision_author: {
        label: "settings_document_live_revision_author",
        data: "liveRevisionAuthor",
      },
      global_topic: {
        label: "global_topic",
        data: "topic",
        type: "DisplayLocation",
      },
      settings_document_categories: {
        label: "settings_document_categories",
        data: "categories",
        type: "string",
      },
    },
    searchHistory: [],
    discussion: [],
    discussionEntry: [],
    // ItemSearches: {

    // },
    // ItemExpertQuestion: {
    //   settings_discussions_posted_by: {
    //     label: "settings_discussions_posted_by",
    //     data: "postedBy",
    //     type: "DisplayUser",
    //   },
    //   settings_discussions_location: {
    //     label: "settings_discussions_location",
    //     data: "topic",
    //     type: "DisplayLocation",
    //   },
    //   settings_discussions_date_created: {
    //     label: "settings_discussions_date_created",
    //     data: "time",
    //     type: "date",
    //   },
    //   settings_discussions_date_last_post: {
    //     label: "",
    //     data: "",
    //     type: "date",
    //   },
    //   settings_expert_question_status: {
    //     label: "",
    //     data: "",
    //     type: "string",
    //   },
    //   settings_expert_question_visibility: {
    //     label: "",
    //     data: "",
    //     type: "string",
    //   },
    //   settings_expert_question_urgency: {
    //     label: "",
    //     data: "",
    //     type: "string",
    //   }
    // },
    ItemKnowledgeItem: {
      settings_knowledge_item_description: {
        label: "settings_knowledge_item_description",
        data: "description",
        type: "string",
      },
      global_topic: {
        label: "global_topic",
        data: "topic",
        type: "DisplayLocation",
      },
      settings_knowledge_item_author_name: {
        label: "settings_knowledge_item_author_name",
        data: "author",
        type: "DisplayUser",
      },
      settings_knowledge_item_live_revision_author: {
        label: "settings_knowledge_item_live_revision_author",
        data: "liveRevisionAuthor",
        type: "DisplayUser",
      },
      settings_knowledge_item_knowledge_source_name: {
        label: "settings_knowledge_item_knowledge_source_name",
        data: "knowledgeSource.description",
        type: "string",
      },
      settings_knowledge_item_created_date: {
        label: "settings_knowledge_item_created_date",
        data: "createdDate",
        type: "date",
      },
      settings_knowledge_item_modified_date: {
        label: "settings_knowledge_item_modified_date",
        data: "modifiedDate",
        type: "date",
      },
      settings_knowledge_item_approved_date: {
        label: "settings_knowledge_item_approved_date",
        data: "approvedDate",
        type: "date",
      },
      settings_knowledge_item_withdraw_date: {
        label: "settings_knowledge_item_withdraw_date",
        data: "withdrawDate",
        type: "date",
      },
      settings_knowledge_item_expiry_date: {
        label: "settings_knowledge_item_expiry_date",
        data: "expiryDate",
        type: "date",
      },
      settings_knowledge_item_document_title: {
        label: "settings_knowledge_item_document_title",
        data: "documentTitle",
        type: "string",
      },
      settings_knowledge_item_visible_date: {
        label: "settings_knowledge_item_visible_date",
        data: "visibleDate",
        type: "date",
      },
      settings_knowledge_item_revalidation_behaviour: {
        label: "settings_knowledge_item_revalidation_behaviour",
        data: "revalidationBehaviour",
        type: "string",
      },
      settings_knowledge_item_revalidation_date: {
        label: "settings_knowledge_item_revalidation_date",
        data: "revalidationDate",
        type: "date",
      },
      settings_knowledge_item_is_ready_for_approval: {
        label: "settings_knowledge_item_is_ready_for_approval",
        data: "readyForApproval",
        type: "boolean",
      },
      settings_knowledge_item_document_type_name: {
        label: "settings_knowledge_item_document_type_name",
        data: "documentTypeId",
        type: "DisplayDocumentType",
      },
      settings_document_categories: {
        label: "settings_document_categories",
        data: "categories",
        type: "string",
      },
    },
  },
  action
) => {
  return state;
};
